import './ProductImage.scss'

import {Background, Picture} from '@codeurs/front'
import placeholder from 'assets/images/placeholder.png'
import React, {useState} from 'react'
import {style} from '../../../../util/style'
import {ProductPreviewType} from '../../pages/WebshopProduct'

const styles = style('productimage')

export const ProductImage: React.FC<
	ProductPreviewType & {noHover?: boolean}
> = ({noHover, image, blur, title}) => {
	const [isLoaded, setLoaded] = useState(false)
	const altText = (image && image.alt) || title || 'Broederlijk delen product'
	return (
		<div
			className={styles
				.mod({blur: blur && image && image.src})
				.mod({nohover: noHover})
				.is({loaded: isLoaded})}
		>
			<Background
				className={styles('background').toString()}
				img={image || placeholder}
				alt={altText}
			/>
			{blur && image && image.src && (
				<Picture
					{...image}
					onLoad={() => setLoaded(true)}
					className={styles('picture').toString()}
					alt={altText}
				/>
			)}
			<div className={styles('overlay')} />
		</div>
	)
}
